import invoiceModule from '../module'
import finderModalPage from '../view/copyInvoice.html'

class InvoiceFinderCtrl {
    constructor($scope, httpRequest, $uibModalInstance, invType, $filter) {
        httpRequest.get_dictByTypeArr(['ovat_tax_rate', 'specific_element']).then((res) => {
            $scope.dictData = res.data.value
            $scope.dictData.inv_Type = [
                {
                    enumName: '电子专用发票',
                    enumCode: '52',
                },
                {
                    enumName: '电子普通发票',
                    enumCode: '51',
                },
                {
                    enumName: '纸质专用发票',
                    enumCode: '0',
                },
                {
                    enumName: '纸质普通发票',
                    enumCode: '2',
                },
            ]
            $scope.dictData.inv_tax4_Type = [
                {
                    enumCode: '61',
                    enumName: '全电电子普票',
                },
                {
                    enumCode: '62',
                    enumName: '全电电子专票',
                },
            ]
        })
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 5,
            totalItems: 0,
            param: {
                applyDateBegin: '',
                applyDateEnd: '',
                createUser: '',
                custNameCreditCode: '',
                invSort: '',
                invType,
                invoiceCode: '',
                invoiceNumber: '',
                electricInvoiceNum: '',
                // orgId: $scope.modaldata.currentOrgId,
                billCode: '',
                isRed: '0',
                invoiceDateBegin: $filter('date')(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
                invoiceDateEnd: $filter('date')(new Date(), 'yyyy-MM-dd'),
                taxRate: '',
            },
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        $scope.selectedHandle = function selectedHandle() {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            $scope.search()
        }

        // 增加排序功能
        $scope.orderMap = {
            sortKey: 'invoiceDate',
            sortVal: 'desc',
        }
        $scope.queryParam.orderMap = { invoiceDate: 'desc' }

        function queryList(v) {
            let queryApi = 'post_qryOvatInvoiceCopyList'
            if (v.param.invType == '61') {
                queryApi = 'post_tax4OrdinaryCopyList'
            }
            if (v.param.invType == '62') {
                queryApi = 'post_tax4SpecialCopyList'
            }
            if (v.param.invType == '' && ($scope.invType == '61' || $scope.invType == '62')) {
                queryApi = 'post_tax4OrdinaryCopyList'
            }
            httpRequest[queryApi](v).then((res) => {
                $scope.invoiceList = res.data.value.list
                $scope.queryParam.totalItems = res.data.value.total
            })
        }
        $scope.pageChange = function pageChange() {
            queryList($scope.queryParam)
        }
        $scope.search = function search() {
            $scope.queryParam.pageNum = 1
            queryList($scope.queryParam)
        }
        $scope.search()
        $scope.chooseInvoice = function chooseInvoice(item) {
            if (item.tableSource === '0') {
                httpRequest
                    .get_queryOvatInvoiceWait({
                        waitId: item.waitOrInvoiceId,
                    })
                    .then((res) => {
                        $uibModalInstance.close(res.data.value)
                    })
            } else {
                httpRequest.post_getOvatInvoice(item.waitOrInvoiceId).then((res) => {
                    const params = {
                        pageNum: 0,
                        pageSize: 0,
                        param: {
                            invoiceID: item.waitOrInvoiceId,
                            needSumLine: false,
                        },
                    }
                    const result = res.data.value
                    httpRequest.post_getPageInvoiceDetail(params).then((res) => {
                        const list = res.data.value && res.data.value.list
                        if (list) result.invoiceDetailList = res.data.value.list
                        $uibModalInstance.close(result)
                    })
                })
            }
        }
    }
}
InvoiceFinderCtrl.$inject = ['$scope', 'httpRequest', '$uibModalInstance', 'invType', '$filter']

invoiceModule.controller('invoiceFinderCtrl', InvoiceFinderCtrl)

invoiceModule.component('invoiceFinder', {
    bindings: {
        invType: '<',
        onSelect: '&',
    },
    template: `
        <button class="btn btn-default btn-xs" ng-click="ctrl.openDialog()">复制</button>
    `,
    controllerAs: 'ctrl',
    controller: [
        'httpRequest',
        '$uibModal',
        function ctrl(httpRequest, $uibModal) {
            const finder = this
            finder.openDialog = function openDialog() {
                const modalInstance = $uibModal.open({
                    template: finderModalPage,
                    controller: 'invoiceFinderCtrl',
                    openedClass: 'mod-modal-haslist blue-invoice-list mod-modal mod-modal-so-hg',
                    backdrop: 'static',
                    resolve: {
                        invType() {
                            return finder.invType
                        },
                    },
                })
                modalInstance.result.then(
                    (item) => {
                        finder.onSelect({
                            item,
                        })
                    },
                    () => {}
                )
            }
        },
    ],
})



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/invoiceFinder.js